export const EnumTokens = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  GOOGLE_TOKEN: "google_token",
};

// User Roles - matching backend enum UserRole
export enum UserRole {
  USER = 'user',
  OWNER = 'owner',
  GUEST = 'guest',
  USER_REALTOR = 'user_realtor',
}

// Admin Roles - matching backend enum AdminRole  
export enum AdminRole {
  REALTOR = 'realtor',
  MAIN_REALTOR = 'main_realtor',
  SECRETARY = 'secretary',
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
}

// Combined type for all roles
export type AnyRole = UserRole | AdminRole;

// Role hierarchy map for permission checking
export const ROLE_HIERARCHY: Record<string, string[]> = {
  // Admin roles have access to all user roles
  [AdminRole.SUPER_ADMIN]: [
    AdminRole.ADMIN, AdminRole.REALTOR, AdminRole.MAIN_REALTOR, AdminRole.SECRETARY,
    UserRole.USER, UserRole.OWNER, UserRole.GUEST, UserRole.USER_REALTOR
  ],
  [AdminRole.ADMIN]: [
    AdminRole.REALTOR, AdminRole.MAIN_REALTOR, AdminRole.SECRETARY,
    UserRole.USER, UserRole.OWNER, UserRole.GUEST, UserRole.USER_REALTOR
  ],
  [AdminRole.MAIN_REALTOR]: [
    AdminRole.REALTOR, AdminRole.SECRETARY,
    UserRole.USER, UserRole.OWNER, UserRole.GUEST, UserRole.USER_REALTOR
  ],
  [AdminRole.REALTOR]: [
    UserRole.USER, UserRole.OWNER, UserRole.GUEST, UserRole.USER_REALTOR
  ],
  [AdminRole.SECRETARY]: [
    UserRole.USER, UserRole.OWNER, UserRole.GUEST
  ],
  // User roles
  [UserRole.USER_REALTOR]: [UserRole.USER, UserRole.OWNER, UserRole.GUEST],
  [UserRole.OWNER]: [UserRole.USER, UserRole.GUEST],
  [UserRole.USER]: [UserRole.GUEST],
  [UserRole.GUEST]: [],
};

// Legacy roles for backward compatibility - DEPRECATED
export const LEGACY_ROLES = {
  USER: 'user',
  REALTOR: 'realtor', 
  ADMIN: 'admin',
  DEVELOPER: 'developer', // This was mapped to super_admin
} as const;
